import { profile as _profile } from '@gonfalon/bootstrap-data/bootstrapData';
// oxlint-disable-next-line no-restricted-imports
import { fromJS, Map } from '@gonfalon/immutable-shim/immutableShim';

import { createMember } from '#utils/members/records/Member';

import type { ProfileState } from './profile';

export function getProfileInitialState(initialState: ReturnType<typeof _profile> = _profile()) {
  const state: ProfileState = Map({
    entity: undefined,
    lastFetched: null,
    isFetching: false,
  });

  const p = initialState;

  if (p) {
    return state.merge({
      lastFetched: Date.now(),
      entity: createMember(fromJS(p)),
    });
  }

  return state;
}
